import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  Avatar,
  Badge,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Chip,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  LinearProgress,
} from "@material-ui/core";
import {
  Add,
  FilterList,
  Dashboard as DashboardIcon,
  ArrowDropUp,
  ArrowDropDown,
  FiberManualRecord as Circle,
  ConfirmationNumber,
  AccountBalance,
  AccountBalanceWallet,
  Payment,
  Print,
  Store,
  Close,
  AcUnit,
  ChevronRight,
  SurroundSound,
  ArrowDropUpOutlined,
  CreditCard,
  DevicesOther,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles, withStyles, useTheme } from "@material-ui/styles";
import Chart from "react-apexcharts";

import {
  ticketsNumber,
  channelPerform,
  operatorPerform,
  agentTransactions,
  agentsPerformance,
  revenueSplit,
  channelFinancial,
  channelTransactions,
  channelWallets,
  financialTransactions,
  inventorySales,
  routePerform,
} from "./testData.jsx";

import Format from "date-fns/format";
import { useSnackbar } from "notistack";

import { Skeleton, Pagination } from "@material-ui/lab";


import { AdminService, Validator } from "./../../../utils/web_config";
import {
  useChannelPerformance,
  useRoutePerformance,
  useOperatorPerformance,
  useAgentTransactions,
  useInventory,
  useTransactions
} from "./../hooks/use_dashboard";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    paddingBottom: 10,
  },
  action: {
    borderRadius: 15,
  },
}));

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 8,
    borderRadius: 5,
    marginTop: 2,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main,
  },
}))(LinearProgress);

function Dashboard(props) {
  const classes = useStyles();
  const history = useHistory();

  const theme = useTheme();

  const [accountData, setAccountData] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [from, setFrom] = useState({
    value: new Date(),
    error: "",
  });
  const [to, setTo] = useState({
    value: new Date(),
    error: "",
  });

  useEffect(() => {
    const t = theme.palette.type;
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    

    revenueSplit.options["theme"] = { mode: t };
    channelFinancial.options["theme"] = { mode: t };
    channelTransactions.options["theme"] = { mode: t };
    channelWallets.options["theme"] = { mode: t };
    financialTransactions.options["theme"] = { mode: t };
    inventorySales.options["theme"] = { mode: t };
  }, []);

  const [generalChannelData, getGeneraChannel] = useChannelPerformance({
    start_date: Format(from.value, ["yyyy-MM-dd"]),
    end_date: Format(to.value, ["yyyy-MM-dd"]),
  });

  const [generalRouteData, getGeneralRoute] = useRoutePerformance({
    start_date: Format(from.value, ["yyyy-MM-dd"]),
    end_date: Format(to.value, ["yyyy-MM-dd"]),
  });

  const [generalOperatorData, getGeneralOperator] = useOperatorPerformance({
    start_date: Format(from.value, ["yyyy-MM-dd"]),
    end_date: Format(to.value, ["yyyy-MM-dd"]),
  });

  const [agentTransactionsData, getAgentTransactions] = useAgentTransactions({
    start_date: Format(from.value, ["yyyy-MM-dd"]),
    end_date: Format(to.value, ["yyyy-MM-dd"]),
  });

  const [inventoryData, getInventory] = useInventory({
    organization_id: new AdminService().accountData.organization
      ?.organization_id,
  });

  const [transactionsData, getTransactions] = useTransactions({
    start_date: Format(from.value, ["yyyy-MM-dd"]),
    end_date: Format(to.value, ["yyyy-MM-dd"]),
  });
  /////////////////////
  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };
  const onDelete = () => {};
  ///////////////////////

  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}
      <Box display="flex">
        <Box mr={2}>
          <DashboardIcon color="primary" fontSize="large" />
        </Box>
        <Typography variant="h5" className={classes.title}>
          <b>Dashboard</b>
        </Typography>
      </Box>
      <Box mt={3} />

      <Grid container spacing={2}>

        <Grid item xs={12}>
          <Box display="flex">
            <Typography style={{ flexGrow: 1 }} variant="h6">
              Transactions
            </Typography>
            <Button endIcon={<ChevronRight />} onClick={()=>history.push("/centrika/reports/finance")}>More</Button>
          </Box>
        </Grid>
        <Grid container spacing={2}>

        {transactionsData?.data?.length==0?<Box p={3}><Typography color='textSecondary'>No transactions available at the moment.</Typography> </Box>:transactionsData?.keys?.map((tr, i) => (
          <Grid item xs={12} md={4} lg={3}>
            <Paper elevation={0} className={classes.paper}>
              <Box width={1}>
                <Box display="flex" width={1}>
                  <Box flexGrow={1}>
                    <Typography className={classes.btn} color="textSecondary">
                      {tr.toLowerCase()}
                    </Typography>
                
                  </Box>
                  {new Validator().getTransactionIcon(tr,true)}
                </Box>
                <Box
                  mt={1}
                  mb="4px"
                  display="flex"
                  alignItems="flex-end"
                  justifyContent="space-between"
                  width={1}
                >
                  <Tooltip
                    title={transactionsData?.groups[tr].length}
                    arrow
                    placement="top"
                  >
                    <Typography variant="h4">
                      {new Validator().formatNumber(
                        transactionsData?.groups[tr].length
                      )}
                    </Typography>
                  </Tooltip>

                  <Typography color="primary" align="right">

                  <Tooltip
                    title= {new Validator().formatMoney(
                      new Validator().sum(transactionsData?.groups[tr], "amount")
                    )+" Rwf"} 
                    arrow
                    placement="top"
                  >
                  <Typography color='textSecondary'>
                  {new Validator().formatNumber(
                      new Validator().sum(transactionsData?.groups[tr], "amount")
                    )} Rwf
                  </Typography>
                  </Tooltip>
                   
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}

{transactionsData.status=='loading'&&[1,2,3,4]?.map((tr, i) => (
          <Grid item xs={12} md={4} lg={3}>
            <Paper elevation={0}>
            <Skeleton
              variant="rect"
              width={"100%"}
              height={100}
              style={{ borderRadius: 4}}
            />
            </Paper>
          </Grid>
        ))}
      </Grid>
        <Grid item xs={12}>
          <Box display="flex">
            <Typography style={{ flexGrow: 1 }} variant="h6">
              Transportation
            </Typography>
            <Button endIcon={<ChevronRight />}>More</Button>
          </Box>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" flexDirection="column" width={1}>
              <Typography color="textSecondary">Channel performance</Typography>
              <Box flexGrow={1} width="100%" display="flex">
                <Chart
                  options={
                    channelPerform(theme.palette.type, generalChannelData)
                      .options
                  }
                  series={
                    channelPerform(theme.palette.type, generalChannelData)
                      .series
                  }
                  type="donut"
                  height={235}
                />
              </Box>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={8}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" width={1}>
              <Box display="flex" flexDirection="column" width={1}>
                <Box mb={2}>
                  <Typography color="textSecondary">
                    First 5 Routes performance
                  </Typography>
                </Box>
                <Box>
                  <Chart
                    options={
                      routePerform(theme.palette.type, generalRouteData).options
                    }
                    series={
                      routePerform(theme.palette.type, generalRouteData).series
                    }
                    type="bar"
                    height={207}
                  />
                </Box>
              </Box>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" flexDirection="column" width={1} height={1}>
              <Box>
                <Typography color="textSecondary">
                  Company comparizon
                </Typography>
              </Box>
              <Box>
                <Box>
                  <Chart
                    options={
                      operatorPerform(theme.palette.type, generalOperatorData)
                        .options
                    }
                    series={
                      operatorPerform(theme.palette.type, generalOperatorData)
                        .series
                    }
                    type="donut"
                    height={300}
                  />
                </Box>
                <List>
                  {generalOperatorData?.data?.labels?.map((item, i) => (
                    <ListItem button>
                      <ListItemAvatar>
                        <Avatar style={{ height: 30, width: 30 }}>
                          {generalOperatorData?.grp[item][0].company?.charAt(0)}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                       primary={ <Typography wrap>{generalOperatorData?.grp[item][0].company}</Typography>}
                      />
                      <Tooltip title={new Validator().formatMoney(
                            generalOperatorData?.data?.series[i]
                          )} arrow
                          placement="top">
                      <ListItemSecondaryAction>
                        <Typography>
                          <b>{new Validator().formatNumber(
                            generalOperatorData?.data?.series[i]
                          )}</b>
                        </Typography>
                       
                      </ListItemSecondaryAction>
                      </Tooltip>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" flexDirection="column" width={1}>
              <Box height={1}>
                <Typography color="textSecondary">Revenue split</Typography>
              </Box>
              <Box>
                <Chart
                  options={revenueSplit.options}
                  series={revenueSplit.series}
                  type="bar"
                  height={320}
                />
              </Box>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Box display="flex">
            <Typography style={{ flexGrow: 1 }} variant="h6">
              Agents
            </Typography>
            <Button endIcon={<ChevronRight />}>More</Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper elevation={0} className={classes.paper}>
            <Box width={1}>
              <Box>
                <Typography color="textSecondary">
                  Agent transactions
                </Typography>
              </Box>
              <Box mt={1} mb="0px" width={0}>
              <Tooltip  arrow
                    placement="top" title= {new Validator().formatMoney(
                    agentTransactionsData?.data?.sum
                  )}>
                <Typography variant="h4">
                  {new Validator().formatNumber(
                    agentTransactionsData?.data?.sum
                  )}
                </Typography>
                </Tooltip>
              </Box>
              <Chart
                options={
                  agentTransactions(theme.palette.type, agentTransactionsData)
                    .options
                }
                series={
                  agentTransactions(theme.palette.type, agentTransactionsData)
                    .series
                }
                type="area"
              />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper elevation={0} className={classes.paper}>
            <Box width={1}>
              <Box>
                <Typography color="textSecondary">
                  Agents performance
                </Typography>
              </Box>
              <Box mt={1} mb="0px" width={0}>
                <Tooltip  arrow
                    placement="top" title= {new Validator().formatMoney(
                    agentTransactionsData?.data?.sum2
                  )}>
                <Typography variant="h4">
                  {new Validator().formatNumber(
                    agentTransactionsData?.data?.sum2
                  )}
                </Typography>
                </Tooltip>
              </Box>
              <Chart
                options={
                  agentsPerformance(theme.palette.type, agentTransactionsData)
                    .options
                }
                series={
                  agentsPerformance(theme.palette.type, agentTransactionsData)
                    .series
                }
                type="area"
              />
            </Box>
          </Paper>
        </Grid>
        {/* <Grid item xs={12} md={7}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" flexDirection="column" width={1}>
              <Box>
                <Typography color="textSecondary">Top ten agents</Typography>
              </Box>
              <Box>
                <List>
                  {[8, 6, 5, 4, 3, 2, 1].map((item, i) => (
                    <ListItem button dense>
                      <ListItemAvatar>
                        <Avatar style={{ height: 30, width: 30 }}>
                          <Typography>{i + 1}</Typography>
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Box
                            pr={7}
                            width={1}
                            display="flex"
                            justifyContent="space-between"
                          >
                            <Typography>Agent name</Typography>
                            <Badge
                              badgeContent={item * 10 + "%"}
                              color="secondary"
                            ></Badge>
                            <Box width={100}>
                              <BorderLinearProgress
                                variant="determinate"
                                value={item * 10}
                              />
                            </Box>
                          </Box>
                        }
                      />
                      <ListItemSecondaryAction>
                        {" "}
                        <Typography>{item * 100} Rwf</Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>
          </Paper>
        </Grid> */}
        <Grid item xs={12}>
          <Box display="flex">
            <Typography style={{ flexGrow: 1 }} variant="h6">
              Customers
            </Typography>
            <Button endIcon={<ChevronRight />}>More</Button>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Paper elevation={0} className={classes.paper}>
            <Typography color="textSecondary">New customer wallets</Typography>
            <Box display="flex" width={1}>
             
              <Chart
                options={channelWallets.options}
                series={channelWallets.series}
                type="donut"
                height={120}
              />
            </Box>
          </Paper>
        </Grid>
{/* 
        <Grid item xs={12} sm={6} md={4}>
          <Paper elevation={0} className={classes.paper}>
            <Typography color="textSecondary">
              Transactions per channel
            </Typography>
            <Box display="flex" width={1}>
              
              <Chart
                options={channelTransactions.options}
                series={channelTransactions.series}
                type="donut"
                height={120}
              />
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Paper elevation={0} className={classes.paper}>
            <Typography color="textSecondary">
              Financial transactions
            </Typography>
            <Box display="flex" width={1}>
             
              <Chart
                options={channelFinancial.options}
                series={channelFinancial.series}
                type="donut"
                height={120}
              />
            </Box>
          </Paper>
        </Grid> */}
        {/* <Grid item xs={12} md={5}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" flexDirection="column" width={1}>
              <Box mb={2}>
                <Typography color="textSecondary">
                  Wallets per district
                </Typography>
              </Box>
              <Box>
                <List>
                  {[8, 6, 5, 4, 3, 2, 1].map((item, i) => (
                    <ListItem button dense>
                      <ListItemAvatar>
                        <AcUnit />
                      </ListItemAvatar>
                      <ListItemText primary="District name" />
                      <ListItemSecondaryAction>
                        <Chip
                          color="secondary"
                          size="small"
                          label={Math.floor(Math.random() * 9999)}
                          deleteIcon={
                            Math.floor(Math.random() * 9) / 2 === 0 ? (
                              <ArrowDropDown />
                            ) : (
                              <ArrowDropUp />
                            )
                          }
                          onDelete={onDelete}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Box>
          </Paper>
        </Grid> */}
        {/* <Grid item xs={12} md={7}>
          <Paper elevation={0} className={classes.paper}>
            <Box width={1}>
              <Box>
                <Typography color="textSecondary">
                  Daily financial transactions
                </Typography>
              </Box>
              <Box mt={1}>
                <Typography variant="h4">00.0</Typography>
              </Box>
              <Box>
                <Chart
                  options={financialTransactions.options}
                  series={financialTransactions.series}
                  type="area"
                  height={227}
                />
              </Box>
            </Box>
          </Paper>
        </Grid> */}

        <Grid item xs={12}>
          <Box display="flex">
            <Typography style={{ flexGrow: 1 }} variant="h6">
              Inventory
            </Typography>
            <Button endIcon={<ChevronRight />} onClick={()=>history.push("/centrika/inventory")}>More</Button>
          </Box>
        </Grid>

        {inventoryData?.data?.map((st, i) => (
          <Grid item xs={12} sm={4} lg={3}>
            <Paper elevation={0} className={classes.paper}>
              <Box width={1}>
                <Box display="flex" width={1}>
                  <Box flexGrow={1}>
                    <Typography>{st.itemTypeName}</Typography>
                    <Typography color="textSecondary">{st.itemName}</Typography>
                  </Box>
                  {st.itemTypeName == "CARD" ? (
                    <CreditCard color="primary" fontSize="large" />
                  ) : (
                    <DevicesOther color="primary" fontSize="large" />
                  )}
                </Box>
                <Box
                  mt={1}
                  mb="4px"
                  display="flex"
                  alignItems="flex-end"
                  justifyContent="space-between"
                  width={1}
                >
                  <Tooltip title={st.quantity} arrow placement="top">
                    <Typography variant="h4">
                      {new Validator().formatNumber(st.quantity)}
                    </Typography>
                  </Tooltip>
                  {st.damagedQuantity != 0 && (
                    <Typography color="error" align="right">
                      {new Validator().formatNumber(st.damagedQuantity)} NoK
                    </Typography>
                  )}
                </Box>
                {/* <Chart
                options={inventoryPos.options}
                series={inventoryPos.series}
                type="pie"
                height={150}
              /> */}
              </Box>
            </Paper>
          </Grid>
        ))}

        {/* <Grid item xs={12} sm={12} md={6}>
          <Paper elevation={0} className={classes.paper}>
            <Box width={1}>
              <Box>
                <Typography color="textSecondary">Total stock sales</Typography>
              </Box>
              <Box mt={1}>
                <Typography variant="h4">1.6M</Typography>
              </Box>
              <Box>
                <Chart
                  options={inventorySales.options}
                  series={inventorySales.series}
                  type="area"
                />
              </Box>
            </Box>
          </Paper>
        </Grid> */}
      </Grid>
    </div>
  );
}

export default withLocalize(Dashboard);
